import findDomain from './findDomain';
import generateCountryURL from './generateCountryURL';

export default (country_code, from_script = false) => {
  const domain = findDomain(country_code);
  $(window).trigger('willRedirect');
  window.top.location.href = generateCountryURL(country_code, domain, from_script);

};
